import api from './api'

// GET GetWorkAreaDetails
const GetAllWorkAreas = () => api.get('/BookingDetails/GetWorkAreaDetails')

// GET GetVehicleDetails
const GetAllVehicles = () => api.get('/VehicleDetails/GetVehicleDetails')

// GET CheckAvailability
const CheckVehicleAvailability = (vid, bdate, starttime, endtime) =>
    api.get(`/BookingRegister/CheckAvailability?vid=${vid}&bdate=${bdate}&starttime=${starttime}&endtime=${endtime}`)

// POST ForkBooking
const PostScheduleBooking = (payload) => api.post('/BookingRegister/ForkBooking', payload)

// GET GetMainForkBookingDetails
const GetMainForkBookingDetails = () => api.get('/BookingRegister/GetMainForkBookingDetails')

// GET GetWorkAreaDetails 
const GetWorkAreaDetails = () => api.get('/BookingDetails/GetWorkAreaDetails')

// GET GetVehicleDetails 
const GetVehicleDetails = () => api.get('/VehicleDetails/GetVehicleDetails')

const ScheduleBookingService = {
    GetAllWorkAreas,
    GetAllVehicles,
    CheckVehicleAvailability,
    PostScheduleBooking,
    GetMainForkBookingDetails,
    GetWorkAreaDetails,
    GetVehicleDetails,
}

export default ScheduleBookingService